import React from 'react';

/**

<Row style="--row-child-margin: 6px;"/>
<Column style="--column-child-margin: 6px;"/>

 */

const justify = {
  center: 'center',
  end: 'end',
  start: 'start',
  around: 'around',
  between: 'between',
};

const align = {
  center: 'center',
  end: 'end',
  start: 'start',
  baseline: 'baseline',
};

const Column = ({
  cb = () => {},
  children,
  spacing = false,
  tag = 'div',
  ...otherProps
}) => {
  const Tag = tag;

  /* eslint-disable no-undef */
  if (process.env.NODE_ENV === 'development') {
    if (children === null) {
      console.warn('A Column with no children makes sense ? ');
    }
  }
  /* eslint-enable */

  const styles = () => {
    let { spacing, x, y } = otherProps;
    let marginChildren = spacing ? `column--child--child-${spacing}` : '';
    return `column-${justify[x]} align-${align[y]} ${marginChildren}`;
  };

  return (
    <Tag {...otherProps} className={styles()} onClick={() => cb()}>
      {children}
    </Tag>
  );
};

const Row = ({
  cb = () => {},
  children,
  spacing = false,
  tag = 'div',
  ...otherProps
}) => {
  const Tag = tag;
  /* eslint-disable no-undef */
  if (process.env.NODE_ENV === 'development') {
    if (children === null) {
      console.warn('A Row with no children makes sense ? ');
    }
  }
  /* eslint-enable */

  const styles = () => {
    let { x, y } = otherProps;
    let marginChildren = spacing ? `row--child--child-${spacing}` : '';
    return `row-${justify[x]} align-${align[y]} ${marginChildren}`;
  };

  return (
    <Tag {...otherProps} className={styles()} onClick={() => cb()}>
      {children}
    </Tag>
  );
};

function Mask({ variant = 'regular ', children, height, width, fill = false }) {
  return (
    <div
      className="col-center align-center"
      style={{
        width,
        height,
        overflow: 'hidden',
        backgroundColor: fill ? fill : 'transparent',
        borderRadius: variant === 'rounded' ? '50%' : '0',
      }}
    >
      {children}
    </div>
  );
}

Mask.Rounded = props => <Mask variant="rounded" {...props} />;

export { Column, Mask, Row };
